import WidgetUrl from 'components/Widgets/WidgetUrl';

const UrlTypeField = ({ item, setNewSelectItem, selectItem, forTable, fromOther }) => {
  if (forTable) {
    return fromOther ? (
      <div>{item.value ? item.value : ' '}</div>
    ) : (
      <div>
        <a href={item.value?.text ?? item.value} target={'_blank'} rel="noreferrer">
          {' '}
          {item.value?.text ?? item.value}{' '}
        </a>
      </div>
    );
  } else {
    return (
      <WidgetUrl
        value={selectItem?.value}
        onChange={(val) =>
          setNewSelectItem({
            value: val ?? ' ',
            setting: {},
          })
        }
      />
    );
  }
};

export default UrlTypeField;
